import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0
};
import useStore from '@/store';

import { ref, computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorLog',
  setup(__props) {
    const dialogTableVisible = ref(false);
    const store = useStore();
    const errorLogs = computed(() => store.errorLog.logs);
    function clearAll() {
      dialogTableVisible.value = false;
      store.errorLog.clearErrorLog();
    }
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_badge = _resolveComponent("el-badge");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _unref(errorLogs).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_badge, {
        "is-dot": true,
        style: {
          "line-height": "25px",
          "margin-top": "-5px"
        },
        onClick: _cache[0] || (_cache[0] = $event => dialogTableVisible.value = true)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          style: {
            "padding": "8px 10px"
          },
          size: "small",
          type: "danger"
        }, {
          default: _withCtx(() => [_createVNode(_component_svg_icon, {
            "icon-class": "bug"
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        visible: _unref(dialogTableVisible),
        width: "80%",
        "append-to-body": ""
      }, {
        title: _withCtx(() => [_createElementVNode("div", null, [_cache[2] || (_cache[2] = _createElementVNode("span", {
          style: {
            "padding-right": "10px"
          }
        }, "Error Log", -1)), _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          icon: "el-icon-delete",
          onClick: clearAll
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("Clear All")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: _unref(errorLogs),
          border: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "Message"
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("div", null, [_cache[3] || (_cache[3] = _createElementVNode("span", {
              class: "message-title"
            }, "Msg:", -1)), _createVNode(_component_el_tag, {
              type: "danger"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(row.err.message), 1)]),
              _: 2
            }, 1024)]), _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)), _createElementVNode("div", null, [_cache[4] || (_cache[4] = _createElementVNode("span", {
              class: "message-title",
              style: {
                "padding-right": "10px"
              }
            }, "Info: ", -1)), _createVNode(_component_el_tag, {
              type: "warning"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(row.vm.$vnode.tag) + " error in " + _toDisplayString(row.info), 1)]),
              _: 2
            }, 1024)]), _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)), _createElementVNode("div", null, [_cache[5] || (_cache[5] = _createElementVNode("span", {
              class: "message-title",
              style: {
                "padding-right": "16px"
              }
            }, "Url: ", -1)), _createVNode(_component_el_tag, {
              type: "success"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(row.url), 1)]),
              _: 2
            }, 1024)])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "Stack"
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.err.stack), 1)]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])]),
        _: 1
      }, 8, ["visible"])])) : _createCommentVNode("", true);
    };
  }
});